import React from 'react'
import { IDatesPickerModalProps } from './dates-picker-modal-props.interface'
import './dates-picker-modal.scss'
import { DatesPicker, BaseSelectionMobileModal } from 'components'
import { useBookingDates } from 'hooks'

const DatesPickerModal: React.FC<IDatesPickerModalProps> = ({ onConfirm, isOpen, setIsOpen, dateFrom, dateTo }) => {
  const { dateFrom: dateFrom_, changeFrom, setDateFrom, dateTo: dateTo_, changeTo, setDateTo } = useBookingDates(dateFrom, dateTo)

  function dismiss() {
    setDateFrom(dateFrom)
    setDateTo(dateTo)
  }

  function clickConfirm() {
    onConfirm(dateFrom_, dateTo_)
  }

  return (
    <BaseSelectionMobileModal
      extraclassName="edisu-dates-picker-modal"
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      onConfirmFunction={() => clickConfirm()}
      onDismissFunction={() => dismiss()}
    >
      <DatesPicker dateFrom={dateFrom_} dateTo={dateTo_} changeFrom={changeFrom} changeTo={changeTo} />
    </BaseSelectionMobileModal>
  )
}

export default DatesPickerModal
